<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>SON EKLENEN RAPORLAR</h1>
          </div>
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">SON EKLENEN RAPORLAR</a></li>
          </ul>
        </div>
        <div style="margin:auto" aria-labelledby="navbarDropdown">
          <!-- <input class="form-control py-2 border-left-0 border" type="search" value="..." id="example-search-input"> -->
          <input
            class="form-control py-2 border-left-0 border"
            style="width:1000px;border-radius:0.25rem"
            type="search"
            v-model="searchString"
            placeholder="ARATMAK İSTEDİĞİNİZ RAPOR İD SİNİ GİRİNİZ"
          />
          <div style="width: 1000px;position: absolute; z-index:1;">
            <ul class="searchCss" style="">
              <li v-for="result in results" :key="result.id">
                <hr />
                <div  @click="routeDetail(result)" style="padding-right: 5px;padding-left: 5px;font-size: 15px;color: black;">
  
                     {{ result.sahaId + "~~~" + result.delgiadeti+ " adet"+ "~~~" +  result.date+ "~~~ Açıklama : " + result.aciklamaone}}
  
                </div>
                <br>
              </li>
            </ul>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-md-12">
            <div class="tile">
              <div class="tile-body">
                <table class="table table-hover table-bordered" id="sampleTable">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Saha Adı</th>
                      <th>Delgi Adeti</th>
                      <th>Açıklama</th>
                      <th>Açıklama 2</th>
                      <th>Tarih</th>
                      <th>İşlem</th>
                    </tr>
                  </thead>
                  <tbody></tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  import { debounce } from "lodash";
  export default {
    data() {
      return {
        searchString: "",
        results: [],
        product: [],
        result: {
          id: "",
          firstname: "",
          lastname: "",
          email: "",
          phone: "",
          tc_number: "",
          imgSrc: "",
          imgUrl: "",
        },
        file: "",
        fileWarn: "",
      };
    },
    watch: {
    searchString: debounce(function() {
      this.search();
    }, 250),
    $route() {
      $("#navbarSupportedContent").collapse("hide");
    },
  },
    mounted() {
      window.scrollTo(0, 0);
      var token = localStorage.getItem("token");
      if(!token){
        this.$router.push("/");
      }
      var results = this.result;
      let datas = [];
  
      let url = store.state.base_url + "AslanSahalar/getAllDelgiSon.php?key=123";
      var datas2 = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        sectionsId: localStorage.getItem("sectionsId"),
      };
  
      axios
        .post(url, JSON.stringify(datas2))
        .then((response) => {
          datas2 = response.data.data;
          var table = $("#sampleTable").DataTable(
             {
                        pageLength: 20,
                        order: [[0, 'desc']]
                    }
          );
          $.each(datas2, function(index, value) {
            table.row
              .add([
                value["id"],
                value["sahaId"],
                value["delgiadeti"] + "  adet",
                value["aciklamaone"],
                value["aciklamatwo"],
                value["date"],
                value["status"],
              ])
              .draw(false);
          });
  
          $("#sampleTable tbody").on("click", "tr", function() {
            var data = table.row(this).data();
            results.id = data[0];
         window.location.href = "#/updatedelgi?id=" + results.id;
          });
        })
        .catch((err) => {
          //console.log(err.response);
        });
    },
  
    methods: {
      routeDetail: function(item) {
      window.location.href = "#/updatedelgi?id=" + item.id;
    },
      goProducts: function() {
        console.log("deneme");
        this.router.navigate(["/staff_detail"], {
          queryParams: { new_id: this.result.id },
        });
        console.log(this.results.id);
      },
      async getFilteredUsers() {
      const filteredUsers = await fetch(
      ' https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/getAllGider.php'
      );
      this.users = await filteredUsers.json();
    },
    search: function() {
      if (this.searchString.length > 0) {
        axios
          .get(
            `https://www.apidosya.aslanyazilimm.com/DosyaApi/AslanSahalar/searchRapor.php?key=123&keyword=${this.searchString}`
          )
          .then((response) => {
            var deger = response.data.length;
            if (deger > 50) {
              this.results = response.data.slice(0, 50);
            } else {
              this.results = response.data;
            }
          });
      } else {
        this.results = null;
      }
    },
    },
  
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  <style>
  .searchCss {
    border-radius: 6px;
    background-color: rgb(215, 98, 98);
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/RaporGuncelleme.vue